module.exports = __webpack_public_path__ + "img/welcome.4d5114b1.svg";